angular.module('property-deal')
    .controller('PropertyDealBankAccountController', function ($http, $scope, $rootScope, $uibModalInstance, data, PropertyDeal) {
        this.$onInit = () => {
            this.form = data
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyDeal.bankAccountUpdate(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                $uibModalInstance.close(this.form);
            })
        };
    })
